import { useAuth } from "@/providers/auth.provider";
import { ProfileForm } from "../components/profile-form";
import { ProfileFormSkeleton } from "../components/profile-form-skeleton";

export default function ProfilePage() {
  const { user: data } = useAuth();

  return (
    <div className="w-full">
      {!data ? <ProfileFormSkeleton /> : <ProfileForm user={data.user} />}
    </div>
  );
}
